const STEPS = ['Jouw situatie', 'Jouw rapport']

/** Two-step progress indicator: solar question, then the report. */
export function AdviceStepper({ current }: { current: 1 | 2 }) {
  return (
    <ol className="flex items-center gap-2 sm:gap-3" aria-label="Stappen">
      {STEPS.map((label, i) => {
        const step = i + 1
        const done = step < current
        const active = step === current
        return (
          <li key={label} className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
            <span
              className={`flex size-9 shrink-0 items-center justify-center rounded-full text-15 font-semibold ${
                active
                  ? 'bg-dark-purple text-white'
                  : done
                    ? 'bg-dark-blue text-beige'
                    : 'bg-beige text-dark-blue/50'
              }`}
              aria-current={active ? 'step' : undefined}
            >
              {done ? (
                <svg viewBox="0 0 13 9" className="size-3" fill="none">
                  <path
                    d="M2 5.375L4.73913 8L11 2"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                step
              )}
            </span>
            <span
              className={`hidden truncate text-15 sm:block ${
                active ? 'font-semibold text-dark-blue' : 'text-dark-blue/50'
              }`}
            >
              {label}
            </span>
            {step < STEPS.length && <span className="h-px flex-1 bg-beige-2" aria-hidden="true" />}
          </li>
        )
      })}
    </ol>
  )
}
